import React, { useEffect, useState } from 'react';

export const useIntersectionHeight = (ref: React.RefObject<HTMLElement>) => {
  const [isOnScreen, setInOnScreen] = useState<boolean>(true);
  const [resizeHeight, setResizeHeight] = useState<number>(0);

  useEffect(() => {
    if (!ref.current) return;
    const resizeObserver = new ResizeObserver(([entry]) => {
      setResizeHeight(entry.borderBoxSize[0]?.blockSize || 0);
    });

    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries.at(-1);
        setInOnScreen(!!entry?.isIntersecting);
      },
      {
        threshold: 1,
      }
    );
    intersectionObserver.observe(ref.current);
    resizeObserver.observe(ref.current);

    return () => {
      intersectionObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, []); // intentional missing deps

  return {
    height: isOnScreen ? resizeHeight : 0,
  };
};
